<template>
  <div>
    <h4 class="ui dividing header">{{ $t("information for pubic use") }}</h4>
    <div class="ui form">
      <div class="field">
        <label>{{ $t("public key") }}</label>
        <!-- <label>{{ process.public_key }}</label> -->
        <div class="ui calendar" ref="public key">
          <div class="ui input left icon">
            <i class="key icon"></i>
            <input readonly type="text" :value="process.public_key" />
          </div>
        </div>
      </div>
      <div class="field" v-show="start_events && start_events.length">
        <label>{{ $t("start elements") }}</label>
        <div class="ui middle aligned  list">
          <div
            class="item"
            v-for="(start_event, sidx) in start_events"
            :key="sidx"
          >
            <i class="user icon"></i>
            <div class="content">
              <div class="ui header">{{ start_event.name }}</div>
              <div class="description">
                <a>{{ start_event.public_url }}</a>
                <!-- <pre>{{ start_event }}</pre> -->
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- <pre>{{ process }}</pre> -->
  </div>
</template>

<script>
import { local_api, error_toast, enterprise_setup } from "@/utils";
import filters from "@/filters";

export default {
  name: "PublicManager",
  filters: filters,
  props: { process: Object },
  data() {
    return {
      start_date: "",
      end_date: "",
      items: [],
    };
  },
  computed: {
    enterprise_setup() {
      return enterprise_setup(this);
    },
    start_events() {
      let vm = this;
      if (vm.process && vm.process.definitions) {
        return vm.process.definitions
          .filter((def) => {
            return def.$type == "bpmn:StartEvent" && !def.eventDefinitions;
          })
          .map((s) => {
            s.public_url = `${window.location.origin}/#/ngine_workspace/external_start?i=${vm.process.public_key}&s=${s.id}`;
            return s;
          });
      } else return [];
    },
  },
  mounted() {
    let vm = this;

    window.jQuery(vm.$refs.range_start).calendar({
      today: true,
      type: "date",
      endCalendar: window.jQuery(vm.$refs.range_end),
      onSelect(value) {
        vm.start_date = value;
      },
    });
    window.jQuery(vm.$refs.range_end).calendar({
      today: true,
      type: "date",
      startCalendar: window.jQuery(vm.$refs.range_start),
      onSelect(value) {
        vm.end_date = value;
      },
    });
  },
  methods: {
    search() {
      let vm = this;
      local_api(vm, "post", "/ngine_core/instance/do-get-errors", {
        i: vm.process.uuid,
        s: vm.start_date,
        e: vm.end_date,
      })
        .then((instances) => {
          vm.items = instances;
          // window.jQuery(vm.$refs.table).DataTable();
        })
        .catch((err) => {
          error_toast(err);
        });
    },
  },
};
</script>
